"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEpisodeVideoRefProperty = exports.episodeVideoRefPropertyDefinition = void 0;
exports.episodeVideoRefPropertyDefinition = {
    view: {
        label: 'Episode videos',
        readonly: true,
        hint: 'Read-only. Please navigate to the content you\'d want to remove or add in order to make changes.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['episode-video'],
        },
    ],
    type: 'child-ref',
    multiple: true,
    name: 'episode-video-ref',
};
const isEpisodeVideoRefProperty = (prop) => {
    return prop.name === exports.episodeVideoRefPropertyDefinition.name;
};
exports.isEpisodeVideoRefProperty = isEpisodeVideoRefProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXBpc29kZS12aWRlby1yZWYucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9lcGlzb2RlLXZpZGVvLXJlZi5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGlDQUFpQyxHQUFHO0lBQy9DLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxnQkFBZ0I7UUFDdkIsUUFBUSxFQUFFLElBQUk7UUFDZCxJQUFJLEVBQUUsa0dBQWtHO0tBQ3pHO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsQ0FBQyxlQUFlLENBQUM7U0FDNUI7S0FDRjtJQUNELElBQUksRUFBRSxXQUFXO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLG1CQUFtQjtDQUNNLENBQUE7QUFJMUIsTUFBTSx5QkFBeUIsR0FBRyxDQUFDLElBQWtCLEVBQW1DLEVBQUU7SUFDL0YsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHlDQUFpQyxDQUFDLElBQUksQ0FBQTtBQUM3RCxDQUFDLENBQUE7QUFGWSxRQUFBLHlCQUF5Qiw2QkFFckMifQ==